import React, { useState } from "react";
import SearchInputField from "./SearchInputField";
const NotFound = (props) => {
  const { location } = props;
  const [code] = useState(new URLSearchParams(location.search).get("code"));

  return (
    <div className="px-6 mt-10 flex flex-col flex-1 text-center max-h-full rounded-md container mx-auto">
      <h2>
        <b>Product not found</b>{" "}
        <span role="img" aria-label="crying emoji">
          😢
        </span>
      </h2>
      <p>The barcode: {code} gave no results!</p>
      <p>You can also enter the barcode below and try again:</p>
      <SearchInputField />
    </div>
  );
};

export default NotFound;
